/**
 * Static example collision data used for the interactive collision preview
 * shown to signed-out users and users with no friends yet.
 *
 * Matches the shape expected by buildCollisionLayout() so the preview
 * can use the real CollisionCanvas with pan, zoom, hover, and LOD rendering.
 */

const exampleCollisionData = {
  zones: {
    coreOverlap: [
      { name: 'Radiohead', image: null },
      { name: 'Tame Impala', image: null },
      { name: 'Frank Ocean', image: null },
      { name: 'Kendrick Lamar', image: null },
    ],
    yourArtists: [
      { name: 'Arctic Monkeys', image: null },
      { name: 'The Strokes', image: null },
      { name: 'Mac DeMarco', image: null },
      { name: 'Khruangbin', image: null },
      { name: 'Boards of Canada', image: null },
    ],
    friendArtists: [
      { name: 'Tyler the Creator', image: null },
      { name: 'Steve Lacy', image: null },
      { name: 'Daniel Caesar', image: null },
      { name: 'SZA', image: null },
      { name: 'Solange', image: null },
    ],
    sharedFrontier: [
      { name: 'King Krule', image: null, score: 0.85, suggestedBy: 'Radiohead' },
      { name: 'Blood Orange', image: null, score: 0.78, suggestedBy: 'Frank Ocean' },
      { name: 'Thundercat', image: null, score: 0.74, suggestedBy: 'Tame Impala' },
    ],
    yourExploration: [
      { name: 'Jorja Smith', image: null, connectedTo: ['Frank Ocean', 'Daniel Caesar'] },
      { name: 'Ravyn Lenae', image: null, connectedTo: ['Steve Lacy'] },
    ],
    friendExploration: [
      { name: 'Pond', image: null, connectedTo: ['Tame Impala', 'Mac DeMarco'] },
      { name: 'Temples', image: null, connectedTo: ['The Strokes'] },
    ],
  },
  links: [
    { source: 'Radiohead', target: 'King Krule' },
    { source: 'Frank Ocean', target: 'Blood Orange' },
    { source: 'Tame Impala', target: 'Thundercat' },
    { source: 'Frank Ocean', target: 'Jorja Smith' },
    { source: 'Daniel Caesar', target: 'Jorja Smith' },
    { source: 'Steve Lacy', target: 'Ravyn Lenae' },
    { source: 'Tame Impala', target: 'Pond' },
    { source: 'Mac DeMarco', target: 'Pond' },
    { source: 'The Strokes', target: 'Temples' },
  ],
};

export default exampleCollisionData;
